import $ from 'jquery';
import {PluralFormat} from "../../../../../../ReactApp/Services/Formatters/PluralFormatter";

const faqV2Semantics = {
    'mainWrapClass': 'faq-v2',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'moreButtonSelector': '.answers__more a',
    'listWrapClass': 'answers__list',
     'toggleOpenActivationClass': 'faq-v2__item',
    'showedElementClass': 'faq-v2__item-body',
    // Количество элементов за один запрос
    'batchSizeAttribute': 'data-batch-size',
    // Атрибут для хранения текущего оффсета
    'offsetAttribute': 'data-offset',
    // все доступное кол-во элементов для показа
    'countBatchElements': 'data-count-batch-elements',
};

/**
 * FaqV2 initializer
 */
$(function () {
    if ($(`.${faqV2Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    let faqV2 = new FaqV2();

    /**
     * Checking other instances
     */

    $(`.${faqV2Semantics.mainWrapClass}`).each((index, el) => {
        let objectElement = $(el);
        let isInitialized =
            ($(el).attr(`${faqV2Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            faqV2.registerInstance(objectElement);
            faqV2.subscribe(objectElement);
            faqV2.loadFaqItems(objectElement);
        }
    });

});

class FaqV2
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${faqV2Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        el.show();
        try {
            el.attr(`${faqV2Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = el;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    /**
     * Subscribe instance
     * @param JQuery element
     * @throws
     */
    subscribe(el) {
        
        // открытие / закрытие ответов.
        $(el).on('click', `.${faqV2Semantics.toggleOpenActivationClass}`, function (e) {
            let $clickedItem = $(this).find(`.${faqV2Semantics.showedElementClass}`);
            let $allItems = $(el).find(`.${faqV2Semantics.showedElementClass}`);

            if ($clickedItem.is(':visible')) {
                $clickedItem.slideUp();
            } else {
                $allItems.slideUp();
                $clickedItem.slideDown();
            }
        });
        
        $(el).on('click', faqV2Semantics.moreButtonSelector, (e) => {
            e.preventDefault();
            this.loadFaqItems($(el));
        });

    }

    loadFaqItems(el) {
        let offset = parseInt(el.attr(faqV2Semantics.offsetAttribute)) || 0;
        // По умолчанию 20 элементов
        let batchSize = parseInt(el.attr(faqV2Semantics.batchSizeAttribute)) || 20;
        // Всего элементов
        let totalCount = parseInt(el.attr(faqV2Semantics.countBatchElements)) || 0;

        let params = {
            ownerModuleTypeId: el.attr('data-owner-module-type-id'),
            ownerObjectTypeId: el.attr('data-owner-object-type-id'),
            offset: offset,
            countOnPage: batchSize
        };
        if (
            typeof el.attr('data-owner-object-id') !== "undefined"
                &&
            el.attr('data-owner-object-id')
        ) {
            params.ownerObjectId = el.attr('data-owner-object-id');
        }

        $.ajax({
            url: '/faq/faq/html-faq-list-v2',
            method: 'GET',
            contentType: 'application/json',
            cache: false,
            data: params,
            success: function (data) {
                if (data.status === true && data.data.length > 0) {
                    el.find(`.${faqV2Semantics.listWrapClass}`)
                        .append(data.data);

                    offset += batchSize;
                    el.attr(faqV2Semantics.offsetAttribute, offset);
                    // Сколько еще осталось
                    let remainingCount = null;
                    if (totalCount - offset < batchSize) {
                        remainingCount = Math.max(0, totalCount - offset);
                    } else {
                        remainingCount = batchSize;
                    }
                    let moreBtn = el.find(faqV2Semantics.moreButtonSelector);
                    if (remainingCount > 0 && moreBtn) {
                        moreBtn.text(`Показать еще ${remainingCount} ${PluralFormat(remainingCount, ['ответ', 'ответа', 'ответов'])}`);
                    } else if (moreBtn) {
                        moreBtn.hide();
                    }
                }
            },
            error: function(data) {
                let instanceId =
                    el.attr(`${faqV2Semantics.instanceIdAttribute}`) || false;
                console.error(
                    `Плагин 
                    [${faqV2Semantics.mainWrapClass}:${instanceId}] 
                    не смог получить данные от endpoint-а faq/faq/html-faq-list, 
                    см. подробности в контексте ошибки:
                `, data);
            }
        });
    }
}